module.exports = "/assets/data/b89662e5840bd4b8b62f64c33ced3807-SW14.data.json";